/**
 * Browser storage keys.
 *
 * Namespaced because localStorage is shared across everything served from an
 * origin. An unprefixed key would collide with anything else on the domain.
 */
export const STORAGE_KEYS = {
  /**
   * A hint that a session probably exists, not a credential.
   *
   * The refresh token used to be stored under a key here. It is now in an
   * httpOnly cookie that script cannot read, which is the whole improvement -
   * see services/api/tokens.ts. All that remains on this side is a flag so boot
   * can skip a refresh that is certain to fail.
   */
  hasSession: 'nudent.hasSession',
} as const;
